import { render, staticRenderFns } from "./SchoolInfoModal.vue?vue&type=template&id=a9824d32"
import script from "./SchoolInfoModal.vue?vue&type=script&lang=js"
export * from "./SchoolInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9824d32')) {
      api.createRecord('a9824d32', component.options)
    } else {
      api.reload('a9824d32', component.options)
    }
    module.hot.accept("./SchoolInfoModal.vue?vue&type=template&id=a9824d32", function () {
      api.rerender('a9824d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolInfo/modules/SchoolInfoModal.vue"
export default component.exports